import * as Lambda from './LambdaApi'

const fetchA4hRoomId = async (registrantId, facilityId) => {
    try {
        const apiPath = `/s2l/${facilityId}/fetchRegistrantRoom`
        const response = await Lambda.Post(apiPath, { registrantId }, 'lambda')
        if (response.success && response.Result.Success) {
            return response.Result.Content
        } else {
            throw new Error('Error in fetching resident\'s a4h room ID!')
        }
    } catch (error) {
        console.error(error)
        throw new Error(error)
    }
}

export {
    fetchA4hRoomId
}
